// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#react-main-app nav#links{margin:30px 0}#react-main-app nav#links a{display:inline-block;border-radius:4px;padding:10px;width:75px;text-align:center}#react-main-app nav#links a.active{color:#fff;background-color:#007bff}\n", ""]);
// Exports
module.exports = exports;
